import axios from 'axios'
import * as waxjs from "@waxio/waxjs/dist";
import Link from 'anchor-link'
import { useToast } from 'vue-toastification'
const toast = useToast()
import {
    isWebUri
} from 'valid-url';
import moment from 'moment';
import BrowserTransport from 'anchor-link-browser-transport'
var keys = null
var laccount = null
if (localStorage.getItem("ual-wax:autologin") != null) {
    let ualWax = JSON.parse(localStorage.getItem("ual-wax:autologin"))
    keys = ualWax ? ualWax.pubKeys : null
}
if (localStorage.getItem("wax_user") != null) {
    laccount = localStorage.getItem("wax_user")
}
const waxOptions = {
    rpcEndpoint: process.env.VUE_APP_CHAIN_URL,
    userAccount: localStorage.getItem("wax_user") || null,
    pubKeys: keys,
    tryAutoLogin: false
}
const getWalletBalance = async(callBack) => {
    return await axios
        .post(`${process.env.VUE_APP_CHAIN_API}/get_currency_balance`, {
            account: localStorage.getItem("wax_user"),
            code: process.env.VUE_APP_TOKEN_CONTRACT,
        }).then(callBack)
}
var wax = new waxjs.WaxJS(waxOptions);

const getImgUrl = (hash, isVideo) => {
    if (isWebUri(hash)) {
        return hash;
    }
    let url = 'http://ipfs.io/ipfs/' + hash;
    if (isVideo) {
        return url
    }
    return '//images.weserv.nl/?url=' + url + "&w=300&h=300";
}
const callApi = async(params, callback) => {
    axios
        .get(`${process.env.VUE_APP_API_ASSET_URL}?owner=${localStorage.getItem('wax_user')}&page=1&limit=100${params}`)
        .then(() => callback)
}
const link = new Link({
    transport: new BrowserTransport({
        requestStatus: false
    }),
    chains: [{
        chainId: process.env.VUE_APP_CHAIN_ID,
        nodeUrl: process.env.VUE_APP_CHAIN_FULL_URL,
    }],
})
const setStake = async(dataParams, onSuccess, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: "atomicassets",
            name: 'transfer',
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams,
        }
        if (localStorage.getItem("ual-session-authenticator") != "wax") {
            return await doSign(actionData, onSuccess, onErrorCallback)
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccess, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const resetOrClaim = async(action, asset_id, onSuccess) => {
    let authenticator = localStorage.getItem("ual-session-authenticator");
    let userAccount = localStorage.getItem("wax_user")
    if (authenticator != "wax") {
        await doSign({
            account: process.env.VUE_APP_CONTRACT,
            name: action,
            authorization: [{
                actor: userAccount,
                permission: 'active',
            }],
            data: {
                account: userAccount,
                nft: asset_id,
            },
        }, (onSuccess), ((error) => {
            toast.error(errorFormat(error));
            return error;
        }));
    } else {
        try {
            await signWithWax({
                actions: [{
                    account: process.env.VUE_APP_CONTRACT,
                    name: action,
                    authorization: [{
                        actor: userAccount,
                        permission: 'active',
                    }],
                    data: {
                        account: userAccount,
                        nft: asset_id,
                    },
                }]
            }, (onSuccess), ((error) => {
                toast.error(errorFormat(error));
                return error;
            }));
        } catch (error) {
            toast.error(errorFormat(error));
            return error;
        }
    }
}
const craft = async(dataParams, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: process.env.VUE_APP_CONTRACT,
            name: "craft",
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams,
        }
        if (localStorage.getItem("ual-session-authenticator") != "wax") {
            return await doSign(actionData, onSuccessCallback, onErrorCallback)
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, onErrorCallback)
        }
    } catch (err) {
        return onErrorCallback(err)
    }
}
const transaction = async(dataParams, onSuccessCallback) => {
    laccount = localStorage.getItem("wax_user");
    try {
        const actionData = {
            account: dataParams.contract,
            name: dataParams.action,
            authorization: [{
                actor: laccount,
                permission: 'active',
            }],
            data: dataParams.data,
        }
        if (localStorage.getItem("ual-session-authenticator") != "wax") {
            return await doSign(actionData, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        } else {
            return await signWithWax({ actions: [actionData] }, onSuccessCallback, (error) => {
                error = errorFormat(error);
                toast.error(error);
            })
        }
    } catch (err) {
        let error = errorFormat(err);
        toast.error(error);
    }
}
const getById = async(id, callback, onError) => {
    return await axios
        .get(`${process.env.VUE_APP_API_ASSET_URL}/${id}`)
        .then(res => res.data.data)
        .then(callback)
        .catch(onError);
}
const getTable = async(table, lowerBound = null, callBack, onError) => {
    const activeUser = localStorage.getItem("wax_user");
    return await wax.rpc.get_table_rows({
        scope: activeUser,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 10000,
        table: table,
        lower_bound: lowerBound
    }).then(async(res) => {
        if (res.rows.length > 0) {
            return res;
        }
        return [];
    }).then((res) => callBack(res)).catch(onError)
}
const getTableContract = async(table, lowerBound = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: process.env.VUE_APP_CONTRACT,
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 100,
        table: table,
        lower_bound: lowerBound
    }).then(async(res) => {
        if (res.rows.length > 0) {
            return res;
        }
        return [];
    }).then((res) => callBack(res)).catch(onError)
}
const getStake = async(onSuccess) => {
    return await getTable("userstake", null, async(result) => {
            if (result) {
                if (result.length > 0 || result.rows) {
                    await result.rows.map(async(item, i) => {
                        await getById(item.nft, (asset) => {
                            result.rows[i]["asset"] = asset;
                            result.rows[i]["expiredDate"] = moment.utc(item.stake_end).format('YYYY-MM-DDTHH:mm:ss.SSSS');
                            result.rows[i]["currentUtc"] = moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSS');
                        })
                    });
                    return onSuccess(result.rows);
                }
            }
        },
        (error) => {
            toast.error(errorFormat(error));
            return error;
        })
}
const getTotalStakes = async(onSuccess) => {
    return await getTable("total.stakes", null, async(result) => {
            if (result) {
                if (result.length > 0 || result.rows) {
                    await result.rows.map(async(item, i) => {
                        result.rows[i]["expiredDate"] = moment.utc(item.stake_end).format('YYYY-MM-DDTHH:mm:ss.SSSS');
                        result.rows[i]["currentUtc"] = moment.utc(new Date()).format('YYYY-MM-DDTHH:mm:ss.SSSS');
                    });
                    return onSuccess(result.rows);
                }
            }
        },
        (error) => {
            toast.error(errorFormat(error));
            return error;
        })
}
const getHolders = async() => {
    return new Promise((resolve) => {
        return axios.get(`${process.env.VUE_APP_API_AH_URL}/accounts/${laccount}/${process.env.VUE_APP_COLLECTION}`)
            .then((result) => {
                if (result.status == "200" || result.status == "201") {
                    if (result.data && result.data.data.length != 0) {
                        let accounts = result.data.data;
                        const alp = Promise.all(
                            accounts.templates.map(async(element) => {
                                let template_id = element.template_id;
                                return await getByTempleteId(template_id, (res) => {
                                    let row = { count: element.assets, meta: res.data.data };
                                    return row;
                                });
                            })
                        );
                        // return 
                        return resolve(alp);
                    } else {
                        return resolve([]);
                    }
                } else {
                    return resolve([]);
                }
            });
    });
}
const doSign = async(action, onSuccessCallback, onErrorCallback) => {
    await link.restoreSession(process.env.VUE_APP_NAME).then((session) => {
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    }).catch(async(error) => {
        console.log(error);
        const identity = await link.login(process.env.VUE_APP_NAME)
        const { session } = identity
        session.transact({
            actions: [action]
        }, {
            blocksBehind: 1,
            expireSeconds: 120,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
        return error;
    })
}
const verifyTrans = async(res, onSuccessCallback) => {
    // let status = true;
    setTimeout(async() => {
        onSuccessCallback(res);
        //     while (status) {
        //         const trans = await historyApi("get_transaction", { traces: false, id: res.processed.id }, (r) => r.data);
        //         console.log(trans);
        //         if (Object.hasOwn(trans, 'id')) {
        //             status = false;
        //             onSuccessCallback(res);
        //         } else if (Object.hasOwn(trans, 'error') && trans.error.name == "tx_not_found") {
        //             status = true;
        //         } else {
        //             status = false;
        //             onSuccessCallback(res);
        //         }
        //     }
    }, 2000);
}
const signWithWax = async(action, onSuccessCallback, onErrorCallback) => {
    laccount = localStorage.getItem("wax_user");
    let isAutoLoginAvailable = await wax.isAutoLoginAvailable();
    if (!isAutoLoginAvailable) {
        await wax.login();
    }
    try {
        await wax.api.transact(action, {
            blocksBehind: 3,
            expireSeconds: 120,
            broadcast: true,
            sign: true,
        }).then(async(res) => {
            verifyTrans(res, onSuccessCallback);
        }).catch(onErrorCallback)
    } catch (error) {
        return onErrorCallback(error)
    }
}
const isLogin = () => {
    // check local store and also expiry of session
    if (localStorage.getItem('wax_user')) {
        var sessionDate = localStorage.getItem("ual-session-expiration");
        var d1 = new Date();
        var d2 = new Date(sessionDate);
        return moment(d2).isAfter(moment(d1))
    } else {
        return false
    }
}

const errorFormat = (error) => {
    console.log(error.message, typeof error);
    if (typeof error == "string") {
        console.log(error);
        return "Something went wrong."
    }
    if (!error.error && error.message) {
        return error.message
    }
    if (error.error.what) {
        if (error.error.details) {
            return error.error.details[0].message
        }
        return error.error.what;
    } else {
        return "Transaction failed,try again."
    }
}
const actionCall = async(callback) => {
    return await axios
        .get(`https://wax.pink.gg/v2/history/get_actions?account=${localStorage.getItem('wax_user')}&filter=${process.env.VUE_APP_CONTRACT}%3Adailyclaim&skip=0&limit=1&sort=desc`)
        .then(res => res.data.actions)
        .then(callback)
}
const getByTempleteId = async(tmpId, callback) => {
    return axios
        .get(`${process.env.VUE_APP_API_TEMPLATE_URL}/${process.env.VUE_APP_COLLECTION}/${tmpId}`)
        .then((res) => callback(res))
}
const getTableScope = async(table, lowerBound = null, callBack, onError) => {
    return await wax.rpc.get_table_rows({
        scope: localStorage.getItem("wax_user"),
        code: process.env.VUE_APP_CONTRACT,
        index_position: 1,
        json: true,
        limit: 100,
        table: table,
        lower_bound: lowerBound
    }).then((res) => callBack(res)).catch(onError)
}
const getBalance = async(callBack) => {
    return await getTableScope("user.balance", null, callBack);
}
export default {
    errorFormat,
    getByTempleteId,
    getBalance,
    actionCall,
    doSign,
    isLogin,
    getHolders,
    resetOrClaim,
    craft,
    transaction,
    callApi,
    getTable,
    getStake,
    getTotalStakes,
    getTableContract,
    setStake,
    signWithWax,
    getImgUrl,
    getWalletBalance,
}